import { ContactForm, GoogleMap, SubscribeNews } from '../../components';

const Contact = () => {
  return (
    <section>
      <ContactForm />
      <GoogleMap />
      <SubscribeNews />
    </section>
  );
};

export default Contact;
